<script>
import { paramsToListQueryInput } from './utils'
export default {
  name: 'AxisGQL',
  props: {
    query: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      default: () => ({})
    },
    processRows: {
      type: Function,
      required: true
    },
    forceWhere: {
      type: Object,
      default: () => ({})
    },
    queryParams: {
      type: Object,
      default: () => ({})
    },
    initialSortBy: {
      type: Array,
      default: () => []
    },
    context: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      data: null
    }
  },
  computed: {
    queryVariables () {
      return paramsToListQueryInput(this.params, this.forceWhere, this.queryParams)
    }
  },
  methods: {
    refetch () {
      this.$apollo.queries.data.refetch()
    }
  },
  apollo: {
    data () {
      const queryName = this.query.definitions[0].name.value
      const variablesCloned = !this.queryVariables
        ? null
        : JSON.parse(JSON.stringify(this.queryVariables))
      return {
        query: this.query,
        fetchPolicy: 'network-only',
        variables () {
          return this.queryVariables
        },
        skip () {
          return !this.queryVariables
        },
        context () {
          return { ...this.context }
        },
        update (data) {
          const { list, totalCount } = data[queryName]
          const rows = this.processRows(list, variablesCloned)
          this.$emit('data-loaded', {
            rows,
            totalRows: totalCount
          })
          return data[queryName]
        }
      }
    }
  },
  render () {
    return null
  }
}
</script>
